import { LearningProgressRepository } from '@/domain/precon-supporter/learning-progress/LearningProgressRepository';
import { CourseId } from '@/domain/precon-supporter/value-objects/CourseId';

/**
 * 修了テスト完了ユースケース
 * テスト結果ページから呼び出され、合格状態とアドバンスト編希望を保存する
 */
export class CompleteExaminationUseCase {
  constructor(
    private readonly learningProgressRepository: LearningProgressRepository
  ) {}

  /**
   * 修了テストの完了を記録
   * @param courseId - コースID（'basic' | 'advanced'）
   * @param passed - テストに合格したか
   */
  async execute(
    courseId: string,
    passed: boolean,
    passerToken?: string
  ): Promise<void> {
    const course = CourseId.fromString(courseId);
    const progress =
      await this.learningProgressRepository.findByCourseId(course);

    if (!progress) {
      throw new Error('Learning progress not found');
    }

    // 合格した場合のみ記録
    if (passed) {
      const updated = progress.markExaminationAsPassed(passerToken);
      await this.learningProgressRepository.save(updated);
    }
  }
}
